export default [
  '/home',
  '/bill/account', // 账单列表-账户查询
  /^\/data\/.*/, // 数据看板
  /^\/invoice-management\/.*/, // 账单中心
  /^\/level\/.*/, // 等级权益
  /^\/message\/.*/, // 消息中心
  '/assess/kpi',
  '/assess/kpi-detail',
  '/assess/kpi-overview',
]
